export default "__VITE_ASSET__Bms$YNg$__"